import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Col, Form, ListGroup, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "../CandidateDashboard.css";

const BASE_API_URL = process.env.REACT_APP_API_URL;

const DreamCompanySelection = ({
  userId,
  setCompanyName,
  setResumeId,
  setResumeName,
  setQuestions,
  onNext,
}) => {
  const location = useLocation();

  const [companyName, setLocalCompanyName] = useState(
    location.state?.companyName || ""
  );
  const [companySuggestions, setCompanySuggestions] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyNotFoundMessage, setCompanyNotFoundMessage] = useState("");
  const [resumes, setResumes] = useState([]);
  const [resumeId, setLocalResumeId] = useState(location.state?.resumeId || "");
  const [questions, setLocalQuestions] = useState(
    location.state?.questions || {
      whyApply: "",
      whyDream: "",
      whyFit: "",
    }
  );
  const [alreadyApplied, setAlreadyApplied] = useState(false);
  console.log(userId);
  useEffect(() => {
    axios
      .get(`${BASE_API_URL}/getResume?userId=${userId}`)
      .then((res) => setResumes(res.data))
      .catch(() => {});
  }, [userId]);
  const checkDreamApplication = async (company) => {
    if (!company.trim()) return;

    try {
      const res = await axios.get(`${BASE_API_URL}/checkDreamApplication`, {
        params: { userId, companyName: company },
      });
      setAlreadyApplied(res.data); // true if already applied
    } catch (err) {
      console.error("Error checking dream application", err);
      setAlreadyApplied(false);
    }
  };

  // const handleCompanySearch = async (e) => {
  //   const query = e.target.value;
  //   setLocalCompanyName(query);
  //   setCompanyNotFoundMessage("");
  //   if (!query.trim()) {
  //     setCompanySuggestions([]);
  //     return;
  //   }
  //   checkDreamApplication(query);

  //   try {
  //     const res = await axios.get(
  //       `${BASE_API_URL}/searchCompanyNames?companyName=${query}`
  //     );
  //     setCompanySuggestions(res.data);
  //     if (res.data.length === 0) {
  //       setCompanyNotFoundMessage(
  //         `The company "${query}" does not exist, but you can still apply.`
  //       );
  //     }
  //   } catch {
  //     setCompanySuggestions([]);
  //   }
  // };

  const handleCompanySearch = async (e) => {
    let query = e.target.value;

    // Remove trailing space ONLY if it's the last character
    if (query.endsWith(" ") && !query.trim().includes(" ")) {
      query = query.trim();
    }

    setLocalCompanyName(query);
    setCompanyName(query); // ensure parent gets typed value
    setCompanyNotFoundMessage("");

    if (!query.trim()) {
      setCompanySuggestions([]);
      return;
    }

    checkDreamApplication(query);

    try {
      const res = await axios.get(
        `${BASE_API_URL}/searchCompanyNames?companyName=${query}`
      );
      setCompanySuggestions(res.data);

      if (res.data.length === 0) {
        setCompanyNotFoundMessage(
          `The company "${query}" does not exist, but you can still apply.`
        );
      }
    } catch {
      setCompanySuggestions([]);
    }
  };
  const handleCompanyBlur = () => {
    setCompanySuggestions([]);
    setLocalCompanyName((prev) => prev.trim());
    setCompanyName((prev) => prev.trim());
  };

  const handleSelectCompany = (company) => {
    setLocalCompanyName(company.companyName);
    setSelectedCompany(company);
    setCompanySuggestions([]);
    setCompanyName(company.companyName);
    checkDreamApplication(company.companyName);
  };

  const handleQuestionChange = (e) => {
    const { name, value } = e.target;
    setLocalQuestions((prev) => ({ ...prev, [name]: value }));
    setQuestions((prev) => ({ ...prev, [name]: value })); // Update the parent state
  };
  const handleResumeChange = (e) => {
    const selectedId = e.target.value;

    const selectedResume = resumes.find(
      (r) => String(r.id) === String(selectedId)
    );

    setLocalResumeId(selectedId);
    setResumeId(selectedId);
    setResumeName(selectedResume?.message || "");
  };

  const handleNextClick = () => {
    if (
      companyName &&
      resumeId &&
      questions.whyApply &&
      questions.whyDream &&
      questions.whyFit
    ) {
      onNext();
    } else {
      alert("Please fill in all fields before proceeding.");
    }
  };
  return (
    <>
      <Form className="p-4 bg-white rounded shadow-sm">
        <Row>
          <Col md={6}>
            {/* Company */}
            <Form.Group className="mb-3 position-relative">
              <Form.Label className="fw-bold required-label">
                Company Name
              </Form.Label>
              <Form.Control
                value={companyName}
                onChange={handleCompanySearch}
                placeholder="Enter company name"
                // onBlur={handleCompanyBlur}
              />
              {alreadyApplied && (
                <small className="text-danger">
                  You have already applied to "{companyName}" as a dream
                  company.
                </small>
              )}

              {companyNotFoundMessage && (
                <small className="text-danger">{companyNotFoundMessage}</small>
              )}

              {companySuggestions.length > 0 && (
                <ListGroup
                  className="position-absolute w-100 mt-1 shadow"
                  style={{
                    maxHeight: "180px",
                    overflowY: "auto",
                    zIndex: 10,
                  }}
                >
                  {companySuggestions.map((c) => (
                    <ListGroup.Item
                      key={c.id}
                      action
                      onClick={() => handleSelectCompany(c)}
                    >
                      {c.companyName}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </Form.Group>
          </Col>
          <Col md={6}>
            {" "}
            <Form.Group className="mb-4">
              <Form.Label className="fw-bold required-label">
                Select Resume
              </Form.Label>
              <Form.Select
                value={resumeId}
                onChange={handleResumeChange}
                disabled={alreadyApplied}
              >
                <option value="">Select Resume</option>
                {resumes.map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.message}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        {/* Questions */}
        <>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold required-label">
              Why do you want to apply to this company?
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="whyApply"
              value={questions.whyApply}
              onChange={handleQuestionChange}
              placeholder="Your motivation..."
              disabled={alreadyApplied}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold required-label">
              Why do you think this is your dream company?
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="whyDream"
              value={questions.whyDream}
              onChange={handleQuestionChange}
              placeholder="What makes it special?"
              disabled={alreadyApplied}
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold required-label">
              Why are you a good fit for this company?
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="whyFit"
              value={questions.whyFit}
              onChange={handleQuestionChange}
              placeholder="Your skills & strengths..."
              disabled={alreadyApplied}
            />
          </Form.Group>
          <Button
            className="w-50 fw-bold"
            onClick={handleNextClick}
            disabled={
              !companyName ||
              !resumeId ||
              !questions.whyApply ||
              !questions.whyDream ||
              !questions.whyFit ||
              alreadyApplied
            }
          >
            Continue to Next Step
          </Button>
        </>
      </Form>
      <ToastContainer />
    </>
  );
};

export default DreamCompanySelection;
